<template>
  <div>
    <ListSearchToobar v-model="searchRquest" v-bind="searchToobarData" @search='init' ref="topBar" style="position:relative">
      <el-select v-model="optionVal" size="mini" filterable :placeholder="$t('product')" style="width:150px;margin-right:16px;" clearable @change="init">
        <el-option :value="option" v-for="(option, i) in nameOptions" :key="i"></el-option>
      </el-select>
    </ListSearchToobar>
    <el-table :data="tableData" style="width: 100%" :height="tableHeight" v-loading="loading" @row-dblclick="dblclickAction" highlight-current-row v-dynamicLoading="{fn: getListData}" cell-class-name="gray-back" header-row-class-name="highlight-last">
      <el-table-column width="38"></el-table-column>
      <el-table-column type="index" :label="$t('pos')" width="80"></el-table-column>
      <el-table-column prop="name" :label="$t('product_name')" show-overflow-tooltip></el-table-column>
      <el-table-column prop="description" :label="$t('description')" show-overflow-tooltip></el-table-column>
      <el-table-column prop="userMonthPrice" :label="$t('price')" :formatter="priceFormat" show-overflow-tooltip></el-table-column>
      <el-table-column prop="status" :label="$t('status')" :formatter="statusFormat" show-overflow-tooltip></el-table-column>
      <el-table-column prop="operation" :label="$t('operation')" class="temp">
        <template slot-scope="scope">
          <el-tooltip :content="$t('off_the_shelf')" placement="top" effect="light">
            <span v-if="scope.row.status === 10" class="icon" @click="handlePutOff(scope.$index, scope.row)"><i class="icon-color common-icon icon-off"></i></span>
          </el-tooltip>
          <span v-if="scope.row.status === 0">
            <el-tooltip :content="$t('edit')" placement="top" effect="light">
              <span class="icon" @click="handleEdit(scope.$index, scope.row)"><i class="icon-color common-icon icon-modify"></i></span>
            </el-tooltip>
            <el-tooltip :content="$t('delete')" placement="top" effect="light">
              <span class="icon" @click="handleDelete(scope.$index, scope.row)"><i class="icon-color common-icon icon-delete"></i></span>
            </el-tooltip>
          </span>
          <el-tooltip :content="$t('on_the_shelf')" placement="top" effect="light">
            <span v-if="scope.row.status !== 10" class="icon" @click="handlePutOn(scope.$index, scope.row)"><i class="icon-color common-icon icon-on"></i></span>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <Footerbar ref="foot">
      <el-button round @click="addNew" size="small">+ {{ $t('new') }}{{ $t('product') }}</el-button>
      <TotalNum v-bind="totalOptions" :totalData="totalNumber" ref="totalNum" slot="right" />
    </Footerbar>
    <el-dialog :title="textMap[dialogStatus]" width="80%" :visible.sync="dialogVisible" custom-class="dialog-class" :close-on-click-modal="false" :before-close="handleClose">
      <formPage ref="formpage" v-if="dialogVisible" :title="dialogStatus" @dialogVisible="dialogVisibleVal" :formData="formData" :readonly="readonly" />
      <span slot="footer" class="dialog-footer" :class="{'none' : readonly}">
        <el-button type="primary" round @click="handleOkClick" :disabled="clicked" style="width: 200px;">{{ $t('submit') }}</el-button>
        <el-button type="default" round @click="handleCancelClick" style="width: 200px;">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TotalNum from '@/components/TotalNum';
import ListSearchToobar from '@/components/ListSearchToobar';
import Footerbar from '@/components/Footerbar';
import productApi from '@/apis/product';
import dynamicLoading from '@/directive/dynamicLoading/index.js';
import formPage from './formPage';
// import { EventBus } from '../../../../common/eventBus/eventbus';
export default {
  name: 'ProductList',
  data() {
    return {
      clicked: false,
      searchToobarData: {
        showBarRight: true,
        floatRight: true,
        formArray: [
          {
            label: this.$t('status'),
            model: 'statusList',
            type: 'select',
            multiple: true,
            width: false,
            options: [
              {
                value: '0',
                label: 'Draft'
              },
              {
                value: '10',
                label: 'On shelf'
              },
              {
                value: '20',
                label: 'Off shelf'
              }
            ]
          }
        ],
        iconName: 'icon-product',
        componentName: this.$t('product_list')
      },
      tableData: [],
      tableHeight: 0,
      dialogVisible: false,
      readonly: false,
      dialogStatus: '',
      textMap: {
        create: this.$t('new_product'),
        update: this.$t('modify_product')
      },
      formLabelAlign: {
        id: ''
      },
      rowlist: {},
      searchRquest: {
        name: [],
        statusList: []
      },
      totalNumber: 0,
      loading: false,
      totalOptions: {
        flag: false,
        whiteTheme: true,
        type: 'Products'
      },
      formData: {},
      optionVal: [],
      nameOptions: []
    };
  },

  mounted() {
    setTimeout(() => {
      this.init('initFlag');
    }, 100);
    setTimeout(() => {
      this.formArray = [
        {
          label: this.$t('product'),
          model: 'name',
          type: 'select',
          width: false,
          options: this.nameOptions
        },
        {
          label: this.$t('status'),
          model: 'statusList',
          type: 'select',
          multiple: true,
          width: false,
          options: [
            {
              value: '0',
              label: 'Draft'
            },
            {
              value: '10',
              label: 'On shelf'
            },
            {
              value: '20',
              label: 'Off shelf'
            }
          ]
        }
      ];
    }, 200);
    setTimeout(() => {
      const navBarHeight = 80;
      const tabHeight = 10;
      this.tableHeight =
        window.innerHeight -
        navBarHeight -
        tabHeight -
        this.$refs.topBar.$el.offsetHeight -
        this.$refs.foot.$el.offsetHeight + 1;
    }, 100);
  },

  directives: { dynamicLoading },

  methods: {
    async init(flag) {
      this.tableData = [];
      this.getListData(flag);
    },

    async getListData(flag) {
      this.loading = true;
      const req = {
        filter: {
          ...this.searchRquest
        }
      };
      const res = await productApi.productList(req);
      this.totalNumber = res.list.length;
      this.searchToobarData.formArray.optionVal = res.list;
      this.tableData.push.apply(this.tableData, res.list);
      if (flag && flag === 'initFlag') {
        this.nameOptions = [];
        this.tableData.forEach((element) => {
          this.nameOptions.push(element.name);
        });
        console.log(this.nameOptions);
      }
      this.loading = false;
    },

    dialogVisibleVal(val) {
      this.dialogVisible = val;
    },
    addNew() {
      this.formData = {};
      this.dialogStatus = 'create';
      this.dialogVisible = true;
      this.readonly = false;
    },
    handleEdit(index, row) {
      console.log(row);
      this.dialogStatus = 'update';
      this.dialogVisible = true;
      this.readonly = false;
      this.formData = { ...row };
      // this.$nextTick(() => {
      //   EventBus.$emit('handleEdit', row);
      // });
    },

    async handleDelete(index, row) {
      this.$confirm(
        '<div><div class="el-message-box__message"><p style="font-weight: bold;">' +
          this.$t('delete_tip1') +
          '</p><p>' +
          this.$t('delete_tip2') +
          '</p></div></div>',
        {
          confirmButtonText: this.$t('delete'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          dangerouslyUseHTMLString: true,
          roundButton: true,
          customClass: 'delete-message',
          iconClass: 'el-icon-error'
        }
      )
        .then(() => {
          const req = {
            id: row.id
          };
          const res = productApi.deleteProduct(req);
          if (res.reason) {
            this.$message({
              // message: '状态不符',
              message: this.$t('status_discrepancy'),
              type: 'error',
              duration: 5000,
              offset: 80
            });
          } else {
            this.init();
            this.$message({
              message: this.$t('delete_success'),
              type: 'success',
              duration: 5000,
              offset: 80
            });
          }
        })
        .catch(() => {});
    },

    async handlePutOn(index, row) {
      console.log(row);
      const req = {
        id: row.id
      };
      const res = await productApi.putOnProduct(req);
      if (res.reason) {
        this.$message({
          // message: '状态不符',
          message: this.$t('status_discrepancy'),
          type: 'error',
          duration: 5000,
          offset: 80
        });
      } else {
        this.init();
        this.$message({
          // message: '上架成功',
          message: this.$t('launch_success'),
          type: 'success',
          duration: 5000,
          offset: 80
        });
      }
    },

    async handlePutOff(index, row) {
      const req = {
        id: row.id
      };
      const res = await productApi.putOffProduct(req);
      if (res.reason) {
        this.$message({
          // message: '状态不符',
          message: this.$t('status_discrepancy'),
          type: 'error',
          duration: 5000,
          offset: 80
        });
      } else {
        this.init();
        this.$message({
          // message: '下架成功',
          message: this.$t('remove_success'),
          type: 'success',
          duration: 5000,
          offset: 80
        });
      }
    },

    handleClose(done) {
      if (!this.readonly) {
        // this.$confirm('确认关闭？')
        this.$confirm(this.$t('sure_to_close'))
          .then((_) => {
            done();
          })
          .catch((_) => {});
      } else {
        this.closeDialog();
      }
    },

    closeDialog() {
      this.dialogVisible = false;
    },

    dblclickAction(row) {
      this.dialogStatus = 'update';
      this.dialogVisible = true;
      this.readonly = true;
      this.formData = { ...row };
    },

    statusFormat(row, column) {
      if (row.status === 10) {
        return 'On shelf';
      } else if (row.status === 20) {
        return 'Off shelf';
      } else {
        return 'Draft';
      }
    },

    priceFormat(row) {
      return row.userMonthPrice + ' ' + row.currency + '/User/Month';
    },

    handleCancelClick() {
      this.dialogVisible = false;
    },

    handleOkClick() {
      this.clicked = true;
      this.$refs.formpage.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.formpage.Submit();
          this.closeDialog();
          this.clicked = false;
        } else {
          this.clicked = false;
          return false;
        }
      });
    }
  },

  components: {
    ListSearchToobar,
    Footerbar,
    formPage,
    TotalNum
  }
};
</script>

<style lang="scss">
.el-tooltip__popper {
  color: #000 !important;
  max-width: 50%;
  background: #fff !important;
  border: 1px solid #000 !important;
  line-height: 1 !important;
  margin-bottom: 0px !important;
}
.el-tooltip__popper .popper__arrow:after {
  border-top-color: #fff !important;
}
</style>
<style lang="scss">
.dialog-class {
  border-radius: 14px !important;
  .el-dialog__header {
    background-color: #f4f4f4;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    padding: 50px 0 20px 50px;
    text-align: left;
    .el-dialog__title {
      font-size: 24px;
      font-weight: 700;
      color: #292929;
    }
  }

  .el-dialog__body {
    height: 50vh;
    overflow: auto;
    padding: 40px 165px 0;
  }
}

.top-title {
  font-size: 24px;
  font-weight: 700;
  text-align: left;
  color: #292929;
}

.el-dialog__footer {
  padding-top: 20px;
  background: #f4f4f4;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  text-align: center;
}
</style>